/** «160540012345» → «160 540 012 345»: a BIN or an IIN as the order editor and the drawer of an order print it (the figures in threes, nothing else kept). */
export function uinText(uin: string): string {
  return uin.replace(/\D/g, '').replace(/(\d{3})(?=\d)/g, '$1 ');
}

/**
 * «БИН» for the number of a legal entity, «ИИН» for the number of a person (an IP): the fifth digit of a BIN is 4, 5 or 6 (the kind of the entity), the one of an IIN is the tens of a month (0 or 1).
 * One rule for every place that names a number — the order editor and the drawer of an order — so that the same number is never a BIN in one and an IIN in the other.
 */
export function uinKindOf(uin: string): 'BIN' | 'IIN' {
  return /^[0-9]{4}[4-6]/.test(uin.replace(/\D/g, '')) ? 'BIN' : 'IIN';
}
